module.exports = __webpack_public_path__ + "static/media/reservationHistory.abbd905d.png";